import React, {  useEffect} from 'react';
/*import React, { useState , useEffect} from 'react';*/
import leaderImage from '../img/envision/aerospace/bhaskar_reddy_k.jpeg';  // Import the image file
/*import BoardOfDirectorsnavbar from './BoardOfDirectorsnavbar';*/
import { FaLinkedin } from 'react-icons/fa';
import AboutLeadershipsecondcontainer from './AboutLeadershipsecondcontainer';
import Footer from './Footer';
import { useLocation } from 'react-router-dom';
const Leadershirajareddy = () => {
     const location = useLocation();
    
        useEffect(() => {
            window.scrollTo({ top: 0, behavior: "smooth" });
        }, [location]); // Run effect when the route changes
        
    return (
        <div>
            <div style={{ background: "rgb(236 115 34)", marginTop: "80px", height: "63px" }}>
                <h1 style={{ textAlign: "center", paddingTop: "13px" }}>OUR LEADERSHIP</h1>
            </div>
            {/* <BoardOfDirectorsnavbar />    */}
            <div style={styles.rowWrapper}>

                <div style={styles.row}>
                    <div style={styles.widgetSpan}>
                        <div id="hs_cos_wrapper_module_1564397675620228" style={styles.hsCosWrapper}>
                            {/* LazySizes Script */}
                            <script src="https://cdnjs.cloudflare.com/ajax/libs/lazysizes/5.3.2/lazysizes.min.js" async=""></script>

                            <div style={styles.abMembers}>
                                <div style={styles.container}>
                                    <div style={styles.imageColumn}>
                                        <div style={styles.mImage}>
                                            {/* Use the imported image */}
                                            <img
                                                className="ls-is-cached lazyloaded"
                                                src={leaderImage}  // Use the imported image here
                                                alt="Naga Mohan Gollangi"
                                                style={styles.image}
                                            />
                                        </div>
                                    </div>
                                    <div style={styles.textColumn}>
                                        <h1>Bhaskar Reddy.K </h1>
                                        <span>Advisory board member – Strategy & Business Development</span>
                                        <br />

                                        {/* LinkedIn Icon */}
                                        <a href="https://www.linkedin.com/in/bhaskar-reddy-8b630a71/" target="_blank" rel="noopener noreferrer">
                                            <FaLinkedin size={30} color="#0077B5" />
                                        </a>

                                    </div>
                                </div>
                            </div>

                            <div style={styles.memberParagraph}>
                                <div style={styles.container}>
                                    <div style={styles.col12}>
                                        <div style={styles.teamParagraph}>
                                        <p style={{ textAlign: 'justify', fontWeight:'bold', fontSize:'20px' }}>Bhaskar Reddy.K – Advisory Board Member – Strategy & Business Development, DREBCON  </p>
                                            
                                            <p style={{ textAlign: 'justify', marginTop:'10px' }}>
                                                Bhaskar Reddy is a distinguished policy strategist and industry advisor with over 30 years of experience in industrial policy, government affairs, and investment promotion. With a deep understanding of the ESDM, automotive, and food processing sectors, he has played a pivotal role in shaping state-level policies, facilitating over $2 billion in investments, and generating employment for more than 70,000 people. His expertise in strategic partnerships has attracted leading global corporations, including Foxconn, Flex, TCL, and Dixon.
                                                Strategic & Policy Leadership Bhaskar’s career spans leadership roles across government bodies, industry associations, and private sector advisory. He specializes in:
I                                               Industrial Policy Development – Structuring state-level policies to foster sectoral growth Investment Promotion & Infrastructure Planning – Driving high-value investments across mobility, ESDM, and food processing
                                                Public-Private Partnerships – Aligning government, industry, and academia for long-term economic impact Employment & Skilling Initiatives – Designing grassroots-level skilling programs to create a skilled workforce
                                            </p>
                                         
                                            <br></br>
                                            <p style={{ textAlign: 'justify', fontWeight:'bold', fontSize:'20px',  }}>Currently, Bhaskar Reddy is engaged in:</p>
                                           
                                          
                                            <ul style={{ textAlign: 'justify', marginTop:'10px' }}>
                                               
                                                <li style={{marginLeft:"30px"}}>EV Mobility Valley, Andhra Pradesh – Leading the development of a 1000+ acre EV ecosystem to attract $1.5 billion in investments and create over 35,000 jobs </li>
                                                <li style={{marginLeft:"30px"}}>Mega Food Park in Tribal Districts – Spearheading policy and industry collaborations for food processing infrastructure</li>
                                                <li style={{marginLeft:"30px"}}>SiC Semiconductor & Solar Cell Manufacturing – Driving strategic partnerships to establish high-tech manufacturing hubs in India</li>
                                              	<li style={{marginLeft:"30px"}}>Strategic Advisor, People Tech Group – Leading the development of an integrated EV industrial cluster focused on innovation, AI, and sustainable mobility</li>
                                                <li style={{marginLeft:"30px"}}>Business Consultant, BASK Consultants – Advising on UNDP-sponsored sectoral investment projects in Iraq Kurdistan</li>
                                            
                                            </ul>

               
                                            <p style={{ textAlign: 'justify',marginTop:'10px', fontWeight:'bold' }}>
                                            Academic & Professional Excellence 
                                            </p>
                                           
                                            <ul style={{ textAlign: 'justify', marginTop:'10px' }}>
                                               
                                                <li style={{marginLeft:"30px"}}>Master’s Degree in Economics – Loyola College</li>
                                                <li style={{marginLeft:"30px"}}>Extensive experience in policy-making, investment strategy, and government relations</li>
                                   

                                        
                                            
                                            </ul>
                                        
                                    
                                          


                                         
                                         

                                            <p style={{ textAlign: 'justify', fontWeight:'bold',  marginTop:'20px'}}>
                                            Thought Leadership & Publications 
                                            </p>
                                           
                                            <ul style={{ textAlign: 'justify', marginTop:'10px' }}>
                                               
                                                <li style={{marginLeft:"30px"}}>Former CEO, APITA (Andhra Pradesh Information Technology Academy) – Led ESDM investment promotion efforts</li>
                                                <li style={{marginLeft:"30px"}}>Strategic Advisor to Indian Cellular & Electronics Association – Shaped national policy for electronics manufacturing</li>
                                                <li style={{marginLeft:"30px"}}> Facilitated TCL’s manufacturing hub in Tirupati, Andhra Pradesh</li>
                                   

                                                

             
                                            </ul>


                                            <p style={{ textAlign: 'justify',marginTop:'10px', fontWeight:'bold',  }}>
                                            Strategic Vision at DREBCON 
                                            </p>
                                            <p style={{ textAlign: 'justify',marginTop:'10px'}}>As an Advisory Board Member at DREBCON, Bhaskar Reddy provides strategic direction for business growth, market expansion, and policy advocacy. His extensive experience in investment promotion, public policy, and industry collaboration strengthens DREBCON’s position as a leader in compliance, governance, and emerging technology consulting.  </p>
                                           
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <style>
        {`
          body, h1, h2, h3, h4, h5, h6, p {
            font-family: "Helvetica Neue", sans-serif !important;
          }
        `}
      </style>
            </div>
            <AboutLeadershipsecondcontainer />
            <Footer />
        </div>
    );
};

const styles = {
    rowWrapper: {
        display: 'flex',
        justifyContent: 'center',
        padding: '20px 0',
        marginTop: '46px',
    },
    row: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        maxWidth: '1200px',
    },
    widgetSpan: {
        padding: '20px',
    },
    hsCosWrapper: {
        marginBottom: '30px',
    },
    abMembers: {
        display: 'flex',
        flexDirection: 'row',
        marginBottom: '20px',
    },
    container: {
        display: 'flex',
        width: '100%',
        flexWrap: 'wrap',
    },
    imageColumn: {
        flex: 1,
        paddingRight: '20px',
    },
    mImage: {
        width: '100%',
    },
    image: {
        width: '86%',
        borderRadius: '8px',
        border: '1px solid'
    },
    textColumn: {
        flex: 2,
        paddingLeft: '20px',
        display: 'flex',               // Add display flex to enable flexbox layout
        flexDirection: 'column',       // Arrange children in a column
        justifyContent: 'center',     // Vertically center the content
        // alignItems: 'center',         
        // textAlign: 'center',       
    },
    socialLink: {
        display: 'inline-block',
        marginTop: '10px',
    },
    socialIcon: {
        width: '30px',
        height: '30px',
    },
    memberParagraph: {
        padding: '20px',
    },
    col12: {
        width: '100%',
    },
    teamParagraph: {
        fontSize: '16px',
        lineHeight: '1.6',
        color: '#333',
        textAlign: 'justify',  // Added text alignment as justify
    },
};

export default Leadershirajareddy;
